import styled from "styled-components";
import amazon from "assets/images/mobile/amazon.png";
import { fonts } from "styles";

export const Container = styled.section`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: black;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 72px 48px 133px 48px;
`;

export const Amazon = styled.img.attrs({ src: amazon })`
  width: 100%;
  max-width: max-content;
  object-fit: contain;
  margin-bottom: 56px;
  align-self: center;
`;

export const Subtitle = styled.h2`
  font-family: ${fonts.BentonSansRegular};
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 3px;
  color: white;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 56px;
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 40px;
  line-height: 40px;
  text-transform: uppercase;
  color: white;
  margin-bottom: 32px;
`;

export const TextEye = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  color: white;
  line-height: 26px;
  margin-bottom: 32px;
`;

export const Credit = styled.span`
  display: block;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: white;
  margin-bottom: 56px;
`;

export const Text = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: white;

  p {
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
